import { CustomAddedMetric, custTile, TvdMetricGroup, TVDMetricGroupResponse } from "./tvd-types";

/**
 * Class to hold all TVD data that needs to be accessed via observable
 * In future TVD FE refactor, there can be a separate classes for
 * use across FE components and services, and properties to be sent to the PPT 
 */
export class TVDModel {
    // Holds the response returned directly from the tvd-metrics endpoint
    tvdResponse: TVDMetricGroupResponse[] = [];

    /**
     * Holds the TVD metrics to populate the PPT with. 
     * This defaults to all metrics but user can select/deselect metrics
     */
    tvdMetricSelections : TVDMetricGroupResponse[] = [];

    // TVD data formatted to display in UI
    tvdMetricGroups: TvdMetricGroup[] = [];

    //keeps track of custom tiles, key is their title
    custTileDict : Map<string, custTile> | undefined= new Map();

    //holds custom metrics formatted for ppt download
    addedMetrics : CustomAddedMetric[] | undefined = [];

    constructor(
        tvdResponse: TVDMetricGroupResponse[], 
        tvdMetricSelections: TVDMetricGroupResponse[],
        tvdMetricGroups: TvdMetricGroup[], 
        custTileDict?: Map<string, custTile>,
        addedMetrics?: CustomAddedMetric[])
    {
        //TVD Metrics
        this.tvdResponse = tvdResponse;
        this.tvdMetricSelections=tvdMetricSelections;

        this.tvdMetricGroups = tvdMetricGroups;

        // Cust tile
        this.custTileDict=custTileDict;
        this.addedMetrics=addedMetrics;
    }

    toString(): string{
        return `tvdResponse=${this.tvdResponse}, 
                tvdMetricSelections=${this.tvdMetricSelections}, 
                tvdMetricGroups=${this.tvdMetricGroups},
                custTileDict=${this.custTileDict},
                addedMetrics=${this.addedMetrics}
                `;
    }
}